import React from 'react';

const PrivacyPolicy = {
    version: '1.0.2',
    element: (
        <div className={'py-1'} data-testid="privacy-notice">
            <p className={'py-1 text-xs text-gray-600'}>
                Effective Date: Nov 10, 2025
            </p>
            <div className="font-bold py-3 text-lg">
                European ICP Personal Data Privacy Notice
            </div>
            <p>
                This privacy notice is applicable to individuals located in the
                United Kingdom, Switzerland, or European Union who have been
                invited to participate in the D. E. Shaw group’s Industry
                Consultant Program (the “ICP”)(“you”). The purpose of this
                personal data privacy notice is to inform you about how your
                personal data (i.e., information that directly or indirectly
                identifies you) is processed by D. E. Shaw & Co., L.P. (“D. E.
                Shaw U.S.”) and D. E. Shaw & Co. (London), LLP (“D. E. Shaw
                London”)(collectively, “we”, “us”, “our”). We are data
                controllers of your personal data.
            </p>
            <div className={'py-4'}>
                <p className={'font-bold py-1'}>
                    What information do we collect?
                </p>
                <div className={'pl-2'}>
                    <ul className={'py-1'}>
                        We may collect some or all of the following information
                        about you:
                        <li className={'pl-4'}>
                            &#9679; Name, home address, business address, and
                            contact details, including email address and
                            telephone number; <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Information you provided during the
                            engagement process, including details of your
                            qualifications, skills, experience, current
                            employment, and employment history, as well as
                            responses to oversight or screening questions and
                            any sample work product provided by you; <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Payment information including your agreed
                            compensation rate, financial account details, and
                            Tax ID ; and
                            <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Any other information that you voluntarily
                            provide to us.
                            <br />
                        </li>
                    </ul>
                    <p className={'py-1'}>
                        We may also perform a periodic background check to
                        ensure your ongoing fitness and propriety to participate
                        in the ICP. When we perform such background checks, this
                        may involve the processing of data relating to criminal
                        convictions and offences, which we will process with
                        your consent and in accordance with applicable law, and
                        other personal data such as data that is publicly
                        available about you (e.g. LinkedIn).
                    </p>
                    <p className={'py-1'}>
                        Some of your personal data (as set out above) will be
                        collected from publicly available sources, such as
                        professional social media page (e.g., LinkedIn) or paid
                        information services (e.g., Zoom Info). Consultations
                        conducted by telephone may be monitored or recorded in
                        accordance with applicable regulatory requirements. We
                        may also collect information related to call details
                        (e.g., dates and times of consultations), performance
                        details (e.g., feedback from staff about the quality of
                        a consultation), and reasons for not or no longer
                        engaging with you, where applicable.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold py-1'}>
                    Why do we process your personal data?{' '}
                </p>
                <div className={'pl-2'}>
                    <p>
                        The provision of certain personal data by you is
                        necessary in order for us to:
                        <br />
                        (a) perform our obligations under the ICP contract with
                        you;
                        <br />
                        (b) fulfil our legal and regulatory obligations; or
                        <br />
                        (c) execute other tasks related to our relationship with
                        you that are in in our legitimate interests and for the
                        purposes set out below.
                        <br />
                    </p>
                    <ul className={'py-1'}>
                        Processing your data allows us to:
                        <li className={'pl-4'}>
                            &#9679; identify potential consultants for the ICP;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; conduct ICP consultations to inform our
                            investment research activities;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; administer payment of remuneration in
                            connection with the ICP;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; perform audits and investigate and resolve
                            complaints, grievances, or misconduct;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; prepare for and act in relation to
                            enquiries, investigations, or proceedings by
                            governmental, administrative, judicial or regulatory
                            authorities, including civil litigation;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; monitor communications with engaged
                            consultants where monitoring is conducted in
                            accordance with D. E. Shaw group policies and
                            procedures and applicable laws;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; exercise rights set out in our ICP contract
                            with you or arising under law;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; provide reasonable diligence material to a
                            third party or meet any disclosure obligations as
                            required by law in connection with a potential asset
                            or stock acquisition of a D. E. Shaw group entity,
                            or the outsourcing or insourcing of services
                            provided by employees; and{' '}
                        </li>
                        <li className={'pl-4'}>
                            &#9679; any other purposes relating to the above.
                        </li>
                    </ul>
                    <p className={'py-1'}>
                        When we conduct a background check we may collect
                        information from you or use a third party data service.
                        Those services access information published by
                        government authorities, as well as information available
                        both in the public domain and from proprietary news and
                        related sources. This could result in the processing of
                        information about criminal convictions or offences.
                        Irrespective of whether we obtain such data from you or
                        from a third party, we will process it solely for the
                        limited purposes described above and as authorized by
                        law. We may process your personal data such as your
                        publicly available data (e.g., your name, place of
                        residence, other information that is publicly available
                        about you in the context of our screenings) using
                        artificial intelligence tools (AI) to improve or support
                        the efficiency and speed of our business processes,
                        including for screening, and in accordance with law. The
                        AI we use is a generative AI system which ingests
                        publicly available data about you to put together
                        reports. We do not conduct any automated
                        decision-making, with or without the use of AI, and the
                        output of any AI we use is being carefully reviewed and
                        validated by a human.
                    </p>
                    <p className={'py-1'}>
                        Failure to provide personal data in whole or in part
                        could make it impossible for us to fulfil some or all of
                        our obligations regarding the ICP, or could prevent us
                        from engaging with you.
                    </p>
                    <p className={'py-1'}>
                        <span className={'font-semibold'}>
                            Your Right to Object – please note that you have a
                            right to object to the processing of your personal
                            data where that processing is carried out for our
                            legitimate interests.
                        </span>{' '}
                    </p>
                    <p className={'py-1'}>
                        Unless you give your explicit consent to do so, we will
                        not use your personal data for the purpose of direct
                        marketing of third-party products to you.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold py-1'}>
                    Who has access to your personal data?
                </p>
                <div className={'pl-2'}>
                    <p className={'py-1'}>
                        We may disclose your personal data for the purposes
                        described above to the following recipients: (i) our
                        affiliates, service providers (e.g., IT service
                        providers, background check service providers) and
                        advisors; (ii) law enforcement agencies; (iii) courts,
                        governmental and non-governmental regulators and
                        ombudsmen; (iv) any third party that acquires, or is
                        interested in acquiring or securitizing, all or part of
                        our assets, shares, partnership interests, and/or
                        membership interests, or that succeeds us in carrying on
                        all or a part of our businesses, or services provided to
                        it, whether by merger, acquisition, reorganization or
                        otherwise; (v) as required or permitted by law,
                        including to comply with a subpoena or similar legal,
                        regulatory, or governmental request or process, or (vi)
                        when we believe in good faith that disclosure is legally
                        required or we have a legitimate interest in making a
                        disclosure, such as where necessary to protect our
                        rights and property.
                    </p>
                    <p className={'py-1'}>
                        D. E. Shaw U.S. is headquartered in the U.S., and
                        therefore all personal data you submit directly to D. E.
                        Shaw U.S. will be transferred to the U.S. Such transfers
                        are made to the extent necessary for us to consider your
                        application to participate in the ICP and, if
                        applicable, to undertake the steps necessary to enter
                        into and fulfill any agreements with enter into with
                        you.
                    </p>
                    <p className={'py-1'}>
                        D. E. Shaw London may disclose your personal data for
                        the purposes described above to recipients (including
                        affiliates such as D. E. Shaw U.S.) located in
                        countries, including India and the United States, which
                        may not have data protection laws equivalent to those in
                        the UK. DESCO London has entered into standard
                        contractual clauses (“Model Contracts”) for transfers of
                        personal data from the UK to its non-UK affiliates
                        (including D. E. Shaw U.S.). When D. E. Shaw London
                        transfers your personal data to other recipients outside
                        of the UK, it will enter into a Model Contract with the
                        recipient or seek assurances from the recipient that it
                        has Binding Corporate Rules in place. You can request
                        further details in relation to international transfers
                        including a copy of the Model Contracts by using the
                        contact details provided below.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold py-1'}>
                    For how long do we keep your data?
                </p>
                <div className={'pl-2'}>
                    We will retain your personal data for as long as you are
                    engaged by us and for a period of time after you cease to be
                    engaged by us, or for as long as required or permitted by
                    law, and in either case in accordance with our internal data
                    retention procedures. The criteria used to determine the
                    retention periods include: (i) how long the personal data is
                    needed in connection with the engagement-related activities;
                    (ii) the type of personal data collected; and (iii) whether
                    we are subject to a legal, contractual or similar obligation
                    to retain the data (e.g., mandatory data retention laws,
                    government orders to preserve data relevant to an
                    investigation, or data that must be retained for the
                    purposes of litigation or disputes). If you would like more
                    information about applicable data retention policies, please
                    contact us using the contact details provided below.
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold py-1'}>Your rights</p>
                <div className={'pl-2'}>
                    <ul className={'py-1'}>
                        You have a right to:
                        <li className={'pl-4'}>
                            &#9679; request access to and rectification or
                            erasure of your personal data;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; obtain restriction of processing or object
                            to processing of your personal data;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; ask for a copy of your personal data to be
                            provided to you, or a third party, in a digital
                            format; and
                        </li>
                        <li className={'pl-4'}>
                            &#9679; withdraw consent to the processing of your
                            personal data at any time.
                        </li>
                    </ul>
                    <p className={'py-1'}>
                        We will respond to your request in writing, or orally if
                        requested, as soon as practicable and in any event not
                        more than within one month after receipt of your
                        request. In exceptional cases, we may extend this period
                        by two months and we will provide you with a
                        justification. If you would like to exercise any of
                        these rights, please contact us using the contact
                        details provided below.
                    </p>
                    <p className={'py-1'}>
                        You also have a right to lodge a complaint about the
                        processing of your personal data with the UK{' '}
                        <a
                            href={
                                'https://ico.org.uk/make-a-complaint/data-protection-complaints/'
                            }
                            target="_blank"
                            className={'text-blue-700'}
                            rel="noreferrer"
                        >
                            Information Commissioner’s Office
                        </a>
                        .
                    </p>
                    <p className={'py-1'}>
                        We periodically review and may modify this notice. If we
                        make modifications, we will continue our commitment to
                        keeping your personal data secure.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold'}> Enquiries, requests, or concerns</p>
                <div className={'pl-2'}>
                    All enquiries, requests, or concerns regarding this privacy
                    notice or relating to the processing of your personal data
                    including all requests as detailed in the “Your rights”
                    section above, should be sent to{' '}
                    <a
                        href="mailto: privacy@deshaw.com"
                        target="_blank"
                        className={'text-blue-800'}
                        rel="noreferrer"
                    >
                        privacy@deshaw.com
                    </a>
                    .
                    <ul className={'pl-4 pt-2'}>
                        <li className={'pl-4'}>
                            &#9679; D. E. Shaw & Co., L.P. is located at Two
                            Manhattan West, 375 Ninth Avenue, 52<sup>nd</sup>{' '}
                            Floor, New York, NY 10001, U.S, and can be reached
                            by emailing{' '}
                            <a
                                href="mailto: privacy@deshaw.com"
                                target="_blank"
                                className={'text-blue-800'}
                                rel="noreferrer"
                            >
                                privacy@deshaw.com
                            </a>
                            .
                        </li>
                        <li className={'pl-4'}>
                            &#9679; D. E. Shaw & Co. (London), L.L.C. is located
                            at 55 Baker Street, Seventh Floor, London W1U 8EW,
                            UK, and can be reached by emailing{' '}
                            <a
                                href="mailto: privacy@deshaw.com"
                                target="_blank"
                                className={'text-blue-800'}
                                rel="noreferrer"
                            >
                                privacy@deshaw.com
                            </a>
                            .
                        </li>
                    </ul>
                </div>
                <p className={'py-2'}>
                    D. E. Shaw & Co., L.P. has designated D. E. Shaw & Co.
                    (London), LLP as its representative in the United Kingdom.
                </p>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold'}> Changes to this privacy notice</p>
                <div className={'pl-2'}>
                    The effective date on this notice indicates the date on
                    which this notice was last updated. We periodically will
                    review and may modify this privacy notice.
                </div>
            </div>
        </div>
    ),
};

export default PrivacyPolicy;
